import { render, staticRenderFns } from "./creator.vue?vue&type=template&id=0b478b50&"
import script from "./creator.vue?vue&type=script&lang=js&"
export * from "./creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports